import { Component, Inject, EventEmitter, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { IndicatorsSingleDataModalComponent } from '../indicators-single-data-modal/indicators-single-data-modal.component';
import { NgForm } from '@angular/forms';

@Component({
  selector: 'app-indicators-multiple-data-modal',
  templateUrl: './indicators-multiple-data-modal.component.html',
  styleUrls: [
    './indicators-multiple-data-modal.component.scss',
    '../modal.scss'
  ]
})
export class IndicatorsMultipleDataModalComponent {
  public loading: boolean;
  public onSubmitEvent = new EventEmitter();
  public dataSourceField: any;

  public yearMask = [/[1-2]/, /\d/, /\d/, /\d/];

  @ViewChild("f", { static: true }) f: NgForm;
  constructor(
    public dialogRef: MatDialogRef<IndicatorsSingleDataModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {
    this.dataSourceField = data.fields[0];
    data.fields.shift();
  }

  ngOnInit() {  }

  onNoClick(e): void {
    //IF HAS DATA CONFIRM BEFORE CLOSE
    e.preventDefault();

    //ELSE, JUST CLOSE
    if (this.loading) {
      if (confirm("Você deseja cancelar a operação?")) {
        this.dialogRef.close(false);
      }
    } else
      this.dialogRef.close(false);
  }

  onSubmit(): void | boolean {

    // this.f.form.reset();

    let controls = this.f.controls;
    let controlKeys = Object.keys(controls);
    for (let control of controlKeys) {
      // if (controls[control].pristine && controls[control].value == "")
      //   controls[control].reset();
      controls[control].markAsTouched();
      // controls[control].markAsDirty();
    }

    if (!this.f.dirty) {
      this.dialogRef.close(false);
      return;
    }

    if (this.f.form.valid) {
      this.loading = true;
      this.onSubmitEvent.emit(this.data);
    }

  }

  public isDataSource(type: string): boolean {
    return type == "DATA_SOURCE";
  }

  public isYear(type: string): boolean {
    return type == "YEAR";
  }

  public isValue(type: string): boolean {
    return type == "VALUE";
  }

  public isObservation(type: string): boolean {
    return type == "OBSERVATION";
  }
}